import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { FormBlockContext } from '../form-block';
import FormContainerField from '../form-container-field';
import FormInputColor from '../form-input-color';
import { getSortedInputs } from './utils/getSortedInputs';
import { hasPrices } from './utils/hasPrices';
import { FormFieldColorPickerContainer } from './styles/form-field-color-picker.styled';
class FormFieldColorPicker extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: this.props.value || '',
            valid: true,
        };
        this.handlerState = ({ value, valid }) => {
            this.setState(Object.assign({ valid }, (value ? { value } : {})));
        };
        this.handlerChange = () => {
            const { name, handlerChange } = this.props;
            const { value, valid } = this.state;
            if (handlerChange) {
                handlerChange({
                    name,
                    valid,
                    value,
                });
            }
        };
        this.componentDidMount = () => {
            const { handlerState, name } = this.props;
            const { value } = this.state;
            if (handlerState && name) {
                handlerState({
                    [name]: value.length > 0 ? value : undefined,
                });
            }
        };
        this.componentWillUnmount = () => {
            const { handlerState, name } = this.props;
            if (handlerState && name) {
                handlerState({ [name]: undefined });
            }
        };
        // TODO: This lifecycle method is deprecated and should be removed: https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
        this.UNSAFE_componentWillReceiveProps = (nextProps) => {
            if (this.props.value !== nextProps.value) {
                this.setState({ value: nextProps.value });
            }
        };
        this.componentDidUpdate = (_, prevState) => {
            const { value, valid } = this.state;
            if (value !== prevState.value || valid !== prevState.valid) {
                const { handlerState, name } = this.props;
                if (handlerState && name) {
                    handlerState({
                        [name]: value.length > 0 ? value : undefined,
                    });
                }
                if (valid !== undefined) {
                    this.handlerChange();
                }
            }
        };
    }
    render() {
        const { reference, label, tooltip, name, dataTest, required, textInfo, textValidationMessages, handlerValidation, inputs, onChange, gradient, } = this.props;
        const { valid, value } = this.state;
        const sortedInputs = getSortedInputs(inputs);
        return (_jsx(FormContainerField, { size: "xl", label: label, tooltip: tooltip, reference: reference, required: required, textInfo: textInfo, children: _jsx(FormFieldColorPickerContainer, { className: "PONCHO-form-field-colorpicker", children: sortedInputs &&
                    sortedInputs.map((option, index) => (_jsx(FormInputColor, { gradient: gradient, disabled: option.disabled, label: option.label, name: name, color: option.color, colorImage: option.colorImage, "data-test": `${dataTest}-input-${option.value}`, priceDescription: (hasPrices(sortedInputs) && (option.priceDescription || 'Geen extra kosten')) ||
                            '', textDescription: option.textDescription, reference: `${reference || ''}-${index}`, value: option.value, valid: valid, checked: option.value === value, required: required, textValidationMessages: textValidationMessages, handlerState: this.handlerState, handlerValidation: handlerValidation, onChange: (event) => {
                            if (onChange)
                                onChange(event);
                        } }, option.value))) }) }));
    }
}
FormFieldColorPicker.defaultProps = {
    reference: 'formFieldColorPicker',
    name: 'formFieldColorPicker',
    dataTest: 'form-field-color-picker',
    label: '',
    value: '',
    required: false,
    inputs: [],
    textInfo: '',
    textValidationMessages: {},
    handlerState: () => { },
    handlerChange: (_) => { },
    handlerValidation: (value = '') => new Promise((resolve, reject) => {
        value.length ? resolve() : reject('');
    }),
    onChange: () => { },
};
const FormFieldColorPickerWithContext = (props) => (_jsx(FormBlockContext.Consumer, { children: ({ handlerState }) => _jsx(FormFieldColorPicker, Object.assign({}, props, { handlerState: handlerState })) }));
export default FormFieldColorPickerWithContext;
